import { EMPTY_OBJECT } from '../../../constants/common'
import Button from '../../Button'
import { ICON_HEIGHT_20 } from '../../Icon'
import { AIButton } from '../AIButton'
import { AIButtonIconGradientIdPrefix } from '../AIButton.constants'

import * as styles from './AIButtonText.module.css'

function AIButtonText({
  afterIconProps: {
    height: afterIconHeight = ICON_HEIGHT_20,
    ...afterIconProps
  } = EMPTY_OBJECT,
  beforeIconProps: {
    height: beforeIconHeight = ICON_HEIGHT_20,
    ...beforeIconProps
  } = EMPTY_OBJECT,
  className = styles.aiButtonText,
  textClassName = styles.aiButtonTextLabel,
  ...restProps
}) {
  return (
    <AIButton
      {...restProps}
      Button={Button.Text}
      afterIconProps={{
        ...afterIconProps,
        height: afterIconHeight,
      }}
      beforeIconProps={{
        ...beforeIconProps,
        height: beforeIconHeight,
      }}
      className={className}
      gradientIdPrefix={AIButtonIconGradientIdPrefix.Text}
      textClassName={textClassName}
    />
  )
}

export default AIButtonText
